import objectUtils from '../utils/object-utils'

export default class RecipientEmail {
  constructor (options = {}) {
    this.model = 'RecipientEmail'
    this.id = objectUtils.get(options, 'id', null)

    this.location_id = objectUtils.get(options, 'location_id', null)
    this.user_id = objectUtils.get(options, 'user_id', null)

    this.email = objectUtils.get(options, 'email', null)
    this.label = objectUtils.get(options, 'label', null)
    this.description = objectUtils.get(options, 'description', null)
    this.settings = objectUtils.get(options, 'settings', {})
    this.is_primary = options.is_primary

    // Status and auditing
    this.status = objectUtils.get(options, 'status', null)
    this.created_at = objectUtils.get(options, 'created_at', null)
    this.updated_at = objectUtils.get(options, 'updated_at', null)
  }
}
